import { gql } from '@apollo/client';

const Fragments = {
  documentClauseItem: gql`
    fragment documentClauseItem on DocumentClauseItem {
      clauseId
      clauseCode
      clauseText
      orderNo
      formula
      parentClauseId
      clauseTypeId
      documentTypeId
      validityDays
      mandatory
      enabled
    }
  `
};

export default Fragments;
